import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import NewButton from '@atlaskit/button/new';
import UFOLoadHold from '@atlassian/react-ufo/load-hold';

import { Font } from 'components/visuals';

type Props = {
  'data-account-id': string;
  onClick: () => void;
  isLoading: boolean;
  isRenewUpgrade: boolean;
};

const Button = styled(NewButton)`
  font-family: ${Font.family};
  font-size: 16px;
  font-weight: 500;
  text-align: left;
`;

const ShowPricingButton = (props: Props) =>
  props.isRenewUpgrade ? (
    <UFOLoadHold name="upgrade-changeoptions" hold={props.isLoading}>
      <Button
        interactionName="upgrade-changeoptions"
        {...props}
        iconAfter={ChevronDownIcon}
        shouldFitContainer
        isLoading={props.isLoading}
      >
        <FormattedMessage id="change.show-pricing" />
      </Button>
    </UFOLoadHold>
  ) : (
    <Button {...props} iconAfter={ChevronDownIcon} shouldFitContainer isLoading={props.isLoading}>
      <FormattedMessage id="change.show-pricing" />
    </Button>
  );

export default ShowPricingButton;
